<div>
    <div class="gate d-flex flex-column gap-2 my-3">
        {{ this.session }}
    </div>
    @if (!unlocked) {
        <div class="gate d-flex flex-column gap-2" role="group" [attr.aria-labelledby]="gateLabelId">
            <label [id]="gateLabelId" [for]="gateInputId" translate="PACESPECTOR_GATE_LABEL"></label>
            <input
                [id]="gateInputId"
                [placeholder]="'PACESPECTOR_GATE_LABEL' | translate"
                [(ngModel)]="accessCode"
                name="accessCode"
                [attr.aria-invalid]="'true'"
                (keyup)="unlock()"
                autocomplete="one-time-code"
            />
        </div>
    } @else {
        <alert type="warning">{{ 'PACESPECTOR_ALERT_MSG' | translate }}</alert>
        <tabset>
            <tab heading="Addresses">
                <div class="d-flex flex-column gap-2 my-3">
                    <pace-core-address-spector-ngrx
                        [addresses]="addresses()"
                        (downloadJson)="downloadJson($event)"
                    ></pace-core-address-spector-ngrx>
                </div>
            </tab>
            <tab heading="Timesheets">
                <div class="d-flex flex-column gap-2 my-3">
                    <pace-timesheet-picker
                        [summaries]="summaries()"
                        [selectedTimesheetId]="selectedTimesheet()?.timesheetId"
                        (selected)="onTimesheetSelected($event)"
                    ></pace-timesheet-picker>
                    @if (selectedTimesheet(); as timesheet) {
                        <pace-core-timesheet-spector-ngrx
                            [model]="timesheet"
                            [addressesById]="addressesById()"
                            [notifications]="notifications()"
                            (downloadJson)="downloadJson($event)"
                            (deleteTimesheet)="deleteTimesheet(timesheet.timesheetId)"
                        ></pace-core-timesheet-spector-ngrx>
                    }
                    <div class="d-flex flex-row justify-content-end gap-2 mt-3">
                        <button
                            type="button"
                            class="btn btn-danger"
                            (click)="deleteAllTimesheets()"
                            translate="PACESPECTOR_DELETE_ALL_TIMESHEETS"
                        ></button>
                    </div>
                </div>
            </tab>
        </tabset>
    }
</div>
